function afterImagesResized() {
    
    let container = document.querySelector('body');

    alignProductBlockHeights(container);
}

function alignProductBlockHeights (container) {
  // Default to document body if no container specified
  
  if (typeof container === 'undefined') {
    container = document.querySelector('body');
  }

  console.log('Aligning product block heights in container: ');
  console.log(container);
  // All product blocks must be the same height, for quick-buy alignment
  const collectionListings = container.querySelectorAll('.collection-listing .product-list');
  
  collectionListings.forEach(function(listing) {
    const isCarousel = listing.closest('.carousel') !== null;
    
    if (window.innerWidth >= 768 || isCarousel) {
      let tallest = 0;
      const innerElements = listing.querySelectorAll('.product-block .block-inner .block-inner-inner');
      
      // Find tallest element
      innerElements.forEach(function(element) {
        const height = element.offsetHeight;
        if (height > tallest) {
          tallest = height;
        }
      });
      
      // Set min-height on all block-inner elements
      const blockInners = listing.querySelectorAll('.product-block .block-inner');
      blockInners.forEach(function(blockInner) {
        blockInner.style.minHeight = tallest + 'px';
      });
    } else {
      // Clear min-height on mobile
      const blockInners = listing.querySelectorAll('.product-block .block-inner');
      blockInners.forEach(function(blockInner) {
        blockInner.style.minHeight = '';
      });
    }
  });
};
let resizeTimeout;
window.addEventListener('resize', function() {
    console.log('Window resize event detected')
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(function() {
        window.dispatchEvent(new Event('debouncedresize'))
    }, 250)
});
window.addEventListener('debouncedresize', afterImagesResized)
document.addEventListener('DOMContentLoaded', alignProductBlockHeights)